<app-dialog [hideClose]="hideClose" [loading]="isLoading$.value" class="save-scenario-dialog">
  <ng-container dialog-title *ngIf="!isSaved">
    {{ 'module.modals.saveScenario.doYouWantToSaveThisScenarioHeaderText' | translate }}
  </ng-container>

  <ng-container dialog-content>
    <div class="input-group" *ngIf="!isSaved && !isDuplicate">
      <label class="label">{{ 'module.modals.saveScenario.pleaseEnterTheScenarioNameLabelText' | translate }}</label>
      <input class="input" placeholder="{{ 'module.modals.saveScenario.scenarioNameInputPlaceholderText' | translate }}" type="text" [(ngModel)]="name" />
    </div>
    <div class="input-group" *ngIf="isDuplicate">
      <label class="label">{{ 'module.modals.saveScenario.scenarioNameAlreadyExistsDuplicateLabelText' | translate }}</label>
    </div>
    <div class="saved-description" *ngIf="isSaved">
      {{ 'module.modals.saveScenario.theDataHasBeenEnteredIntoTheSystemDescriptionText' | translate }}
    </div>
  </ng-container>

  <ng-container dialog-actions *ngIf="!isSaved && !isDuplicate">
    <button class="btn btn-outline-primary" [class.-disabled]="!isValid()" (click)="save()">
      {{ 'module.modals.saveScenario.saveFooterPrimaryButtonText' | translate }}
    </button>
    <button class="btn btn-outline-secondary" (click)="close()">{{ 'module.modals.saveScenario.stopFooterSecondaryButtonText' | translate }}</button>
  </ng-container>

  <ng-container dialog-actions *ngIf="isDuplicate">
    <button class="btn btn-outline-primary" (click)="closeDuplicateMessage()">
      {{ 'module.modals.saveScenario.okFooterDuplicateButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
